import { createContext, useContext } from 'react';
import { ActorRefFrom } from 'xstate';
import { malpracticeMachine } from '../malpractice.machine';

type MalpracticeActorRef = ActorRefFrom<typeof malpracticeMachine>;

export const MalpracticeRefContext = createContext<MalpracticeActorRef | null>(null);

export function useMalpracticeActorRef() {
  const ref = useContext(MalpracticeRefContext);
  if (!ref)
    throw new Error('useLicenseActorRef must be used within the AccountActorRefContext.Provider');
  return ref;
}
